namespace RioERP.Web.Enums {
    export enum ShippedBy {
        Self = 1,
        Agency = 2
    }
    Serenity.Decorators.registerEnumType(ShippedBy, 'RioERP.Web.Enums.ShippedBy');
}
